var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1291 10.5757C10.6926 11.1493 10.0946 11.5718 9.41599 11.786C8.73735 12.0001 8.01084 11.9956 7.33477 11.7731C6.6587 11.5506 6.06571 11.1207 5.63604 10.5418C5.20636 9.96279 4.96075 9.26262 4.93244 8.53601C4.90413 7.80941 5.09448 7.09143 5.47774 6.47924C5.861 5.86705 6.41867 5.3902 7.07527 5.11322C7.73188 4.83624 8.45573 4.77249 9.14888 4.93061C9.84203 5.08873 10.471 5.46108 10.9507 5.99727L10.457 6.46042C10.07 6.02782 9.56252 5.72741 9.00329 5.59984C8.44406 5.47227 7.86006 5.5237 7.33031 5.74717C6.80056 5.97064 6.35063 6.35536 6.04142 6.84928C5.73221 7.34319 5.57863 7.92245 5.60147 8.50868C5.62431 9.09491 5.82247 9.6598 6.16913 10.1269C6.51579 10.594 6.99421 10.9408 7.53967 11.1204C8.08512 11.2999 8.67127 11.3035 9.2188 11.1307C9.76633 10.9579 10.2488 10.6171 10.6009 10.1543L11.1291 10.5757Z",
    fill: "#26445A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7891 8.39453C16.7891 13.0307 13.0307 16.7891 8.39453 16.7891C3.75836 16.7891 0 13.0307 0 8.39453C0 3.75836 3.75836 0 8.39453 0C13.0307 0 16.7891 3.75836 16.7891 8.39453ZM0.673817 8.39453C0.673817 12.6586 4.1305 16.1152 8.39453 16.1152C12.6586 16.1152 16.1152 12.6586 16.1152 8.39453C16.1152 4.1305 12.6586 0.673817 8.39453 0.673817C4.1305 0.673817 0.673817 4.1305 0.673817 8.39453Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.1a84147744da56a7d451b57286a83e26.svg";
export { ForwardRef as ReactComponent };